import React, { useState } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import SubHeader from './SubHeader.jsx';

// Section header: title, "Total: N" counter and a "Sort by" dropdown.
// Owns its sort state; the parent is notified through onSortChange.
const SectionHeaderWithSort = ({
  title,
  total,
  sortOptions,
  defaultSort = sortOptions[0],
  onSortChange,
  id = 'sort-type',
}) => {
  const [sortType, setSortType] = useState(defaultSort);

  const handleSelect = (val) => {
    setSortType(val);
    if (onSortChange) onSortChange(val);
  };

  return (
    <SubHeader flexJustify small>
      <div className="flex">
        <h2>{title}</h2>
        <strong className="header-item bordered text-muted">
          Total:&nbsp;
          <span className="text-primary">{total}</span>
        </strong>
      </div>
      <div className="flex">
        <div className="text-muted m-r-16">Sort by</div>
        <ButtonToolbar style={{ width: '250px' }}>
          <DropdownButton
            bsStyle="info"
            id={id}
            title={sortType}
            className="btn-block text-capitalize"
            onSelect={handleSelect}
          >
            {sortOptions.map((type, index) => (
              <MenuItem key={index} active={sortType === type} eventKey={type}>
                <span className="text-capitalize">{type}</span>
              </MenuItem>
            ))}
          </DropdownButton>
        </ButtonToolbar>
      </div>
    </SubHeader>
  );
};

export default SectionHeaderWithSort;
